// ** React Imports
import { lazy } from 'react';

const GeneralSettings = lazy(() => import('../../views/settings/general'));
import PhraseDesign from '../../views/settings/PhraseDesign';

const SettingsRoutes = [
  {
    element: <GeneralSettings />,
    path: '/settings/general',
    meta: {
      permission: 'CONFIG'
    }
  },
  {
    element: <PhraseDesign />,
    path: '/settings/phrase-design',
    meta: {
      permission: 'CONFIG'
    }
  }
];

export default SettingsRoutes;
